import { useRef } from 'react';

// The three input paths are not independent: wheel ignores events mid-drag, drag and wheel both
// cancel an in-flight programmatic scroll, and the scroll listener must tell the two apart.

export interface DragState {
  isPointerDown: boolean;
  isDragging: boolean;
  startX: number;
  scrollLeft: number;
  /** A drag ends with a click; this stops that click activating a card. */
  suppressClick: boolean;
  pointerId: number | null;
}

export interface ProgrammaticScrollState {
  isActive: boolean;
  targetIndex: number;
}

export interface WheelState {
  restoreTimeoutId: number | null;
  inputKind: 'trackpad' | 'wheel' | null;
  inputKindResetId: number | null;
}

export interface ScrollGestureState {
  drag: React.MutableRefObject<DragState>;
  programmatic: React.MutableRefObject<ProgrammaticScrollState>;
  wheel: React.MutableRefObject<WheelState>;
}

export const useScrollGestureState = (): ScrollGestureState => {
  const drag = useRef<DragState>({
    isPointerDown: false,
    isDragging: false,
    startX: 0,
    scrollLeft: 0,
    suppressClick: false,
    pointerId: null,
  });
  const programmatic = useRef<ProgrammaticScrollState>({
    isActive: false,
    targetIndex: 0,
  });
  const wheel = useRef<WheelState>({
    restoreTimeoutId: null,
    inputKind: null,
    inputKindResetId: null,
  });

  return { drag, programmatic, wheel };
};

export const clamp = (value: number, min: number, max: number) => Math.min(Math.max(value, min), max);
